import { generatePath } from 'react-router-dom';

import { Routes, RouteId, RouteItem } from './routes';

export function getRoutes(): RouteItem[] {
  return Routes;
}

export function getRoute(id: RouteId): RouteItem {
  const route = Routes.find((r) => r.id === id);
  if (!route) throw new Error(`Route ${id} not found`);
  return route;
}

export function getRootRoute(id: RouteId): RouteItem {
  const route = getRoute(id);
  if (route.parent) return getRootRoute(route.parent);
  return route;
}

// grp: generate route path
export function grp(id: RouteId, params?: Record<string, unknown>): string {
  const route = getRoute(id);
  try {
    const path = generatePath(route.path, params);
    return path;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return route.path;
  }
}
